/**
 * Property Service
 * API calls for property management
 */

import { apiClient } from './apiClient';
import { Property, PropertyStats, PropertyFilters } from '../types/property';

export const propertyService = {
  /**
   * Get all properties with optional filtering
   */
  async getProperties(filters?: PropertyFilters): Promise<{ properties: Property[]; count: number }> {
    const params = new URLSearchParams();
    
    if (filters?.search) params.append('search', filters.search);
    if (filters?.landlordId && filters.landlordId !== 'all') params.append('landlordId', filters.landlordId);
    if (filters?.type && filters.type !== 'all') params.append('type', filters.type);
    if (filters?.status && filters.status !== 'all') params.append('status', filters.status);
    if (filters?.province) params.append('province', filters.province);

    const response = await apiClient.get(`/getProperties?${params.toString()}`);
    return response.data;
  },

  /**
   * Get property statistics
   */
  async getPropertyStats(): Promise<{ stats: PropertyStats }> {
    const response = await apiClient.get('/getPropertyStats');
    return response.data;
  },

  /**
   * Get property by ID
   */
  async getPropertyById(propertyId: string, landlordId: string): Promise<{ property: Property }> {
    const response = await apiClient.get(`/getPropertyById?propertyId=${propertyId}&landlordId=${landlordId}`);
    return response.data;
  },
};
